import * as React from 'react';
import { Component } from 'react';
import ToolTipIconUI from '../ToolTipIcon/ToolTipIconUI';

export interface ITextInputUIProps {
    analyticsId?: string;
    id?: string;
    label?: string;
    onBlur?: any;
    onBlurValidation?: any;
    onImmediateUpdateValue?: any;
    onUpdateValue?: any;
    textValue?: any;
    isReadOnly?: boolean;
    placeHolder?: string;
    disableOnReadOnly?: boolean;
    showAlert?: boolean;
    forceCursorToEnd?: boolean;
    onAlertClick?: { () };
}

export interface ITextInputUIState {
    textValue?: number;
    displayError?: any;
}

/**
 * TODO: Combine this with CurrencyInputUI somehow. This is basically just copy pasted which means theres some optimizing to do
 */

class TextInputUI extends Component<ITextInputUIProps, ITextInputUIState> {
    debouncedUpdateValue: (() => void);
    constructor(props) {
        super(props);
        this.state = {
            textValue: props.textValue,
            displayError: false
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.textValue !== this.state.textValue) {
            this.setState({ textValue: nextProps.textValue });
        }
    }
    immediateUpdateValue(value) {
        if (this.props.onImmediateUpdateValue) {
            this.props.onImmediateUpdateValue(value);
        }
    }
    onChange(event) {
        this.setState({ displayError: false });
        let value = event.target.value;
        value = value.replace('$', '').replace(/,/g, '');
        this.setState({ textValue: value });
        this.immediateUpdateValue(value); // to update state tree immediately
    }

    onBlur(event) {
        let isValidValue = true;
        if (this.props.onBlurValidation) {
            isValidValue = this.props.onBlurValidation(this.state.textValue);
        }
        if (isValidValue && this.state.textValue) {
            this.setState({ displayError: false });
        } else {
            this.setState({ displayError: true });
        }

        if (this.props.onBlur) {
            this.props.onBlur(event.target.value);
        }
        if (!event.currentTarget.value) {
            const labelNode = event.currentTarget.previousSibling || event.currentTarget;
            labelNode.classList.remove('text-input-touched');
        }
    }

    onFocus(event) {
        if (this.props.forceCursorToEnd) {
            const length = event.target.value.length;
            const inputTarget = event.target;
            if (length > 0) {
                setTimeout(() => {
                    inputTarget.setSelectionRange(length, length);
                },         0);
            }
        }
    }

    onFocused(event) {
        const labelNode = event.currentTarget.previousSibling || event.currentTarget;
        labelNode.classList.add('text-input-touched');
    }

    render() {
        const { label, placeHolder, onAlertClick, id, analyticsId, showAlert, isReadOnly } = this.props;

        const labelDiv = (
            // tslint:disable-next-line:max-line-length
            <div className={`text-input__label control-label inline-label input-label ${this.state.textValue ? 'text-input-touched' : ''}`}>
                {label}
            </div>
        );
        let placeholderText = placeHolder;
        if (this.state.displayError) {
            placeholderText = placeHolder ? placeholderText : 'Enter a valid value';
        }
        const alertComponent = (
            <div className="info-icon">
                <ToolTipIconUI
                    iconClass="info-circle"
                    onClick={onAlertClick}
                />
            </div>
        );
        let inputClasses = 'form-control';
        inputClasses = showAlert ? `${inputClasses} show-alert` : inputClasses;
        inputClasses = isReadOnly ? `${inputClasses} text-input--read-only` : inputClasses;
        const value = this.state.textValue;

        const textInputContainerClasses = `text-input ${this.state.displayError === true ? 'input-validation-fail' : ''}`;

        return (
            <div className={textInputContainerClasses}>
                <div className="input-group">
                    { label ? labelDiv : null }
                    <input
                        className={inputClasses}
                        id={id}
                        data-analytics={analyticsId}
                        type="text"
                        placeholder={placeHolder}
                        value={value}
                        onFocus={(event) => { this.onFocused(event); }}
                        onChange={(event) => { this.onChange(event); }}
                        onBlur={(event) => { this.onBlur(event); }}
                    />
                    { showAlert ? alertComponent : null }
                </div>
            </div>
        );
    }


}

export default TextInputUI;
